import { useRef } from "react";
import "./Login.scss";
import { Modal, Spin, Form, Typography, Input, Button } from "antd";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { resetAuthError } from "../../features/auth/authSlice";
import loginSchema from "../../validations/loginValidation.js";
import { createYupValidator } from "../../utils/validationHelper.js";

export default function Login({
  token,
  title,
  isOpened,
  onCancel,
  onOk,
  openRegister,
  openForgetPassword,
}) {
  const { error, loading } = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <Modal
      style={{
        borderTop: `2px solid ${token?.colorPrimary}`,
      }}
      className="login-cont"
      open={isOpened}
      title={title}
      centered={true}
      destroyOnHidden={true}
      footer={null}
      onCancel={() => {
        formRef?.current?.resetFields();
        onCancel();
        if (error) {
          dispatch(resetAuthError());
        }
        if (pathname === "/login") {
          navigate("/");
        }
      }}>
      <Spin spinning={loading} size="large">
        <Form
          style={{
            maxWidth: 360,
          }}
          className="login-cont__form"
          ref={formRef}
          onFinish={(values) => {
            onOk(
              values,
              () => {
                formRef?.current?.resetFields();
                dispatch(resetAuthError());
              },
              formRef
            );
          }}>
          <div className="login-cont__form__formItemWrapper">
            <Form.Item
              className="login-cont__form__formItemWrapper__formItem"
              name="email"
              rules={[
                {
                  required: true,
                  validator: createYupValidator(loginSchema, "email"),
                },
              ]}>
              <Input
                size="large"
                prefix={<MailOutlined />}
                placeholder="Email"
                autoComplete="username"
                onChange={() => {
                  if (error && error["email"]) {
                    dispatch(resetAuthError("email"));
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              className="login-cont__form__formItemWrapper__formItem"
              name="password"
              rules={[
                {
                  required: true,
                  validator: createYupValidator(loginSchema, "password"),
                },
              ]}>
              <Input.Password
                size="large"
                prefix={<LockOutlined />}
                placeholder="Password"
                autoComplete="current-password"
                onChange={() => {
                  if (error && error["password"]) {
                    dispatch(resetAuthError("password"));
                  }
                }}
              />
            </Form.Item>
          </div>
          <div className="login-cont__form__btnWrapper">
            <Typography.Text
              style={{
                color: token?.colorPrimary,
                display: "inline-block",
                marginLeft: "auto",
              }}
              className="login-cont__form__clickableText"
              strong
              onClick={() => {
                onCancel();
                openForgetPassword();
                if (error) {
                  dispatch(resetAuthError());
                }
                if (pathname === "/login") {
                  navigate("/");
                }
              }}>
              Forgot Password
            </Typography.Text>
            <Button
              block
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              disabled={error ? Object.keys(error)?.length !== 0 : false}>
              Log in
            </Button>
            <div className="login-cont__form__btnWrapper__textWrapper">
              <Typography.Text strong>Or</Typography.Text>
              <Typography.Text
                style={{
                  color: token?.colorPrimary,
                }}
                className="login-cont__form__clickableText"
                strong
                onClick={() => {
                  onCancel();
                  openRegister();
                  if (error) {
                    dispatch(resetAuthError());
                  }
                  if (pathname === "/login") {
                    navigate("/");
                  }
                }}>
                Register Now
              </Typography.Text>
            </div>
          </div>
        </Form>
      </Spin>
    </Modal>
  );
}
